var _circle, _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#5E639B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.1226,
    y: 21.25,
    width: 28.625,
    height: 40.013,
    rx: 1,
    fill: "#F8F8FB",
    stroke: "#BEBECE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5151 31.0601L52.5151 31.0601L52.5197 31.0642L56.6043 34.7069C56.817 34.8966 56.9387 35.1681 56.9387 35.4532V67C56.9387 67.5523 56.491 68.0001 55.9387 68.0001H28.2495C27.6972 68.0001 27.2495 67.5523 27.2495 67.0001V27.5488C27.2495 26.9965 27.6972 26.5488 28.2495 26.5488H47.1344C47.382 26.5488 47.6208 26.6407 47.8046 26.8066L52.5151 31.0601Z",
    fill: "#F8F8FB",
    stroke: "#BEBECE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9028 27L47.9028 32.5564C47.9028 33.661 48.7983 34.5564 49.9028 34.5564H56",
    stroke: "#BEBECE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7396 53.6862L47.8272 53.5765C49.1401 52.0407 49.8622 50.11 49.8622 48.0915C49.8622 43.4622 46.0985 39.6885 41.4814 39.6885C36.8644 39.6885 33.1226 43.4622 33.1226 48.0915C33.1226 52.7208 36.8862 56.4945 41.5033 56.4945C43.3851 56.4945 45.1795 55.8802 46.6674 54.7174L46.7549 54.6516L52.2692 59.1273L53.1226 58.0742L47.7396 53.6862ZM41.5033 55.1342C37.6302 55.1342 34.4792 51.9749 34.4792 48.0915C34.4792 44.2081 37.6302 41.0488 41.5033 41.0488C45.3764 41.0488 48.5274 44.2081 48.5274 48.0915C48.5274 51.9749 45.3764 55.1342 41.5033 55.1342Z",
    fill: "#BEBECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.15 45.2974L38.6392 44.8066L44.9986 51.1871L44.5094 51.6779L38.15 45.2974Z",
    fill: "#BEBECE",
    stroke: "#BEBECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5074 44.8061L44.9966 45.2969L38.6371 51.6773L38.1479 51.1865L44.5074 44.8061Z",
    fill: "#BEBECE",
    stroke: "#BEBECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/NotFoundIcon.5abde5381ee1d8804c29041e7c4cc27f.svg";
export { ForwardRef as ReactComponent };